export default __webpack_public_path__ + "static/media/slack.48a20a75.svg";